// Setup Axios
import Axios from 'axios';
import Vue from 'vue';
import VueAxios from 'vue-axios';

import Config from './config';
import store from './store';

// Setup defaults
Axios.defaults.baseURL = Config.baseURL;
Axios.defaults.withCredentials = true;
Axios.defaults.validateStatus = function (status) {
  return status < 500;
};

// Setup tid interceptor
Axios.interceptors.request.use((config) => {
  const state = store.state.registration;

  if (state.phoneCode) {
    if (state.phoneNumber) {
      config.headers['X-Transaction-Id'] = `+${state.phoneCode}${state.phoneNumber}`;
    }
  }

  return config;
});

// Setup referrer interceptor
Axios.interceptors.request.use((config) => {
  if (document.referrer) {
    if (config.headers) {
      store.dispatch('configuration/setReferrer', document.referrer);
    }
  }

  if (store.state.configuration.referrer) {
    config.headers['X-Referer'] = document.referrer;
  }

  return config;
});

// Enable Vue Axios
Vue.use(VueAxios, Axios);

export default Axios;
